import { render } from "./SongDetailsView.vue?vue&type=template&id=664c4ac0&scoped=true"
import script from "./SongDetailsView.vue?vue&type=script&lang=js"
export * from "./SongDetailsView.vue?vue&type=script&lang=js"

import "./SongDetailsView.vue?vue&type=style&index=0&id=664c4ac0&scoped=true&lang=css"

import exportComponent from "/Users/vaninamikova/Documents/Learning/Old Projects/tab-tracker/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664c4ac0"]])

export default __exports__